import React from 'react';
import {Menu,  Dropdown } from '@cloud/atom-ui';
import {i18n, locale} from '@src/utils/i18n';
import Headers from '../CustomHeader'
import * as nls from './nls';
import useMappedState from '@src/utils/useMappedState';
import history from '@src/utils/history';
import {pclogout} from './thunk';
import webConfig from '@src/configs/web.config';
import navMenuData from './const'
import Certification from '../Certification'
import { urlDomainDeal } from "@src/utils/common";
const I18N = i18n(nls);
const text = I18N;
const lang = locale;
window._Dropdown = Dropdown; // cwp-react Headers 未引入 Dropdown 样式

function getCurrentUrl(isSystem) {
  return '1';
}

export default () => {
  const {user, siteType} = useMappedState('root');
  if (!navMenuData) return null;
  if (navMenuData && siteType && siteType.site_type != 2) {
    navMenuData[3].isShowMenu = 1;
    navMenuData[2].resUrl = "#/wecode/doc";
    navMenuData[2].menuUrl = "#/wecode/doc";
    navMenuData[2].isHref = '1'
  }
  const headerUser = user || {};
  return <Headers
    selectable={false}
    i18n={I18N}
    pageName={text.weOpen}
    lang={lang}
    user={{
      name: headerUser.displayName,
      nameEn: headerUser.displayName_En
    }}
    homeClick={() => {
      history.push('/home'); // 跳转路由
    }}
    navItemData={navMenuData}
    menuIndex="id"
    defaultSelectedKeys={[
      getCurrentUrl(headerUser.systemTenantid === 'system')
    ]}
    navItemClick={item => {
      if (item.isHref === "0") {
        window.location.href = urlDomainDeal(item.menuUrl);
      } else if (item.isHref === "1") {
        let url =
          (
            (window.location.origin.indexOf("//open.") < 0) ?
              window.location.origin.replace("//", "//open.") + "/" :
              ""
          ) +
          item.menuUrl;
        let host = window.location.host;
        if((host.includes('open-icsl') || host.includes('localhost')) && item.id === 'devbench-dev-doc'){
          let reg = /#.*$/g
          url = window.location.href.replace(reg,item.menuUrl)
        }
        window.open(url);
      } else if (item.isHref === "2") {
        window.open(item.menuUrl);
      }
    }}
    dropDownComponent={
      <Menu style={{width: 318}} defaultSelectedKeys={['5']}>
        <Certification/>

        <Menu.HeaderDivider/>
        <Menu.Item
          key="1"
          style={{
            padding: '10px',
            wordBreak: 'break-all',
            whiteSpace: 'normal'
          }}
        >
          <div
            className="amu-headers-useranme">{lang === 'zh' ? headerUser.displayName : headerUser.displayName_En}</div>
          <span className="amu-headers-email">
              {headerUser.accountid}
            </span>
        </Menu.Item>
        <Menu.HeaderDivider/>
        {
          siteType && siteType.site_type == 2 ?
            null
            : <Menu.Item>
              <div
                onClick={() => {
                  const link = 'https://support.huaweicloud.com/admin-welink/start.html';
                  window.open(link);
                }
                }
              >
                {text.help}
              </div>
            </Menu.Item>
        }

        <Menu.HeaderDivider/>
        {headerUser.systemTenantid !== 'system' && <Menu.HeaderDivider/>}
        <Menu.Item>
          <div onClick={async () => {
            const res = await pclogout();
            if (res === 200) {
              sessionStorage.removeItem('ISVVALUE')
              sessionStorage.removeItem('canSeeRoma')
              window.location.href = webConfig.goLoginURl(window.location.href);

            }
          }}>{text.logOut}</div>
        </Menu.Item>
      </Menu>
    }
    logo={{
      url: `${require('@src/assets/logo1.png')}`,
      alt: '',
      style: {height: 20, width: 90},

    }}

  />
}
